import store from '@/store';
import Multiselect from 'vue-multiselect';

/* --------------------------- HELPER FUNCTIONS --------------------------- */

export const replacePlaceholders = (str, args) => {

  if(!str)
    return str;

  let formatedStr = str;

  args.forEach((val, index) => {
    if(val !== undefined)
      formatedStr = formatedStr.replace("{"+index+"}", val).replace("{"+index+"}", val).replace("{"+index+"}", val)
  })

  return formatedStr
}

function finishPreload(preLoader, resolve, response) {
  //Hide loaer
  window.gavlegardarna.loader.hide(preLoader, true);
  //Set the appLoad state to true
  gavlegardarna.app.appLoadStatus = true;

  //Show the navigation if there is any
  if( gavlegardarna.app.nav && gavlegardarna.app.mobilenav ) {
    gavlegardarna.app.nav.$children[0].appLoadStatus = true;
    gavlegardarna.app.mobilenav.$children[0].appLoadStatus = true;
  }

  //Return promise
  resolve(response);
}

/* Get a bunch of data we need for all views */
export const centralDispatch = function() {
  return new Promise((resolve, reject) => {

    const interval = setInterval(() => {
      if(window.gavlegardarna && window.gavlegardarna.loader){
        clearInterval(interval);
        resolve();
      }
    },10)

    //Only run for authenticated users
    //if( auth.checkAuth() && !gavlegardarna.app.appLoadStatus ) {


      // store.cache.dispatch('getProfile').then(function (response, commit) {
      //   //Show loader
      //   let preLoader = window.gavlegardarna.loader.show(document.querySelector('body'), true, true);
      //   //prefetch data
      //   Promise.all([
      //    // store.cache.dispatch('getContracts'),
      // //    store.cache.dispatch('getOffers'),
      //   //  store.cache.dispatch('getSubscriptions'),
      //    // store.cache.dispatch('getNoteofinterests'),
      //     //store.cache.dispatch('getQueuePoints'),
      //     //store.cache.dispatch('getConfig'),
      //     //store.cache.dispatch('getInfoscreenData'),
      //   ])
      //   .catch(e => {
      //     console.log('catch', e);
      //   })
      //   .then(values => {
      //     // gavlegardarna.app.nav.$children[0].hasLaundry = true;
      //     // gavlegardarna.app.mobilenav.$children[0].hasLaundry = true;
      //     // store.dispatch('getToken').then(function (response, commit) {
      //     //   //Show laundry booking in navigation if the user has laundry rooms
      //     //   if(!!gavlegardarna.app.hasLaundry) {
      //     //     gavlegardarna.app.nav.$children[0].hasLaundry = true;
      //     //     gavlegardarna.app.mobilenav.$children[0].hasLaundry = true;
      //     //   }
      //     //   //Finish the preload
      //        finishPreload(preLoader, resolve, response);
      //     // });
      //   })
      // });
   // }
    //else {
      //Return promise
     // resolve();
   // }
  });
}

/* Get a bunch of data we need for all views */
export const renderMode = function() {
  return window.gavlegardarna.webapp_config.render_mode ;
}

export const EMPTY = 'this_is_empty_but_will_run_watchers_if_set_with';

/**
 * Mappar felmeddelandetexten mot de man angett i admin.
 */
export const matchingErrorMessage = (error) => {
    if(error.response){

      let description = ''; // let description = (error.response.data && error.response.data.description ? error.response.data.description : error.response.data).toLowerCase();

      if(error.response.data && error.response.data.description){
        description = error.response.data.description;
      } else if(error.response.data && error.response.data.Message){
        description = error.response.data.Message;
      } else if(typeof error.response.data == 'string'){
        description = error.response.data;
      } else {
        return;
      }

      description = description.toLowerCase();

      // Kollar först om de finns någon exakt matching
      let errorConfig = gavlegardarna.webapp_config.msg.http_errors.find((config, index) => {
        return (config.key.toLowerCase() == description || config.key == error.response.status)
      })

      if(errorConfig)
        return errorConfig;

      // kollar partiell matchninig
      errorConfig = gavlegardarna.webapp_config.msg.http_errors.find((config, index) => {
        return (config.allowPartialMatch && description.indexOf(config.key.toLowerCase()) !== -1)
      })

      if(errorConfig)
        return errorConfig;

      else {
        description = 'general';
        errorConfig = gavlegardarna.webapp_config.msg.http_errors.find((config, index) => {
          return (config.allowPartialMatch && description.indexOf(config.key.toLowerCase()) !== -1)
        })
        return errorConfig;
      }
    }

    return;
}


//You need to be loged in to use these pages
export const requireAuth = async (to, from, next) => {
  if (store.getters.authStatus === null) {
    await store.dispatch('checkAuthStatus');
  }
  if (store.getters.authStatus === false) {
    if (location.hostname == 'localhost'){
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
    else {
      if (location.host == 'www.gavlegardarna.se'){
        window.location.href =
          '/logga-in?returnUrl=' +
          encodeURIComponent(location.href);
      }
      else {
        console.log("location.href", location.href)
        window.location.href =
          '/ny-inloggning?returnUrl=' +
          encodeURIComponent(location.href);
      }

    }
 /*   console.log("NOT LOGGED IN")

    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })*/

  } else {
    next();
  }
}


// Bara om man inte är inloggad
export const requireNotAuth = (to, from, next) => {

  if (store.getters.authStatus === false) {
    next()
  } else {
    next({
      path : '/'
    })
  }
}


export const isIE = () => {
  const userAgent = window.navigator.userAgent || "";

  return !!userAgent.match(/MSIE|Trident/)
}

/* -------------------------------- MIXINS -------------------------------- */

export const htmlDecode = {
  methods: {
    htmlDecode : function(html) {
      var a = document.createElement( 'a' );
      a.innerHTML = html;
      return a.textContent;
    }
  }
}

/* Convert a value and sanitize the input. Fastest according to jsPerf */
export const convertType = {
  methods: {
    convertType : function(value) {
      if (value === "undefined") return undefined;
      if (value === "null") return null;
      if (value === "true") return true;
      if (value === "false") return false;
      var v = Number (value);
      return isNaN (v) ? value : v;
    }
  }
};



/* -------------------------------- Extensions -------------------------------- */

/* Deep clone*/
function deepClone (obj) {
  if (Array.isArray(obj)) {
    return obj.map(deepClone)
  } else if (obj && typeof obj === 'object') {
    var cloned = {}
    var keys = Object.keys(obj)
    for (var i = 0, l = keys.length; i < l; i++) {
      var key = keys[i]
      cloned[key] = deepClone(obj[key])
    }
    return cloned
  } else {
    return obj
  }
}

export const vSelect = {
  mixins: [Multiselect],
  data () {
    return {
      internalValue: this.getInternalValue(this.value)
    }
  },
  props: {
    return: {
      type: String,
      default: ''
    }
  },
  computed: {
    visibleValue: function(){
      if(typeof(this.internalValue) === String) {
        return this.multiple ? this.internalValue.slice(0, this.limit) : [];
      }
      return this.internalValue ? this.internalValue : [];
    },
    valueKeys () {
      if (this.trackBy) {
        return this.internalValue.map(element => element[this.trackBy])
      } else {
        return this.internalValue
      }
    },
  },

  methods: {
    /**
     * Converts the external value to the internal value
     * @returns {Array} returns the internal value
     */
    getInternalValue (value) {
      if (value === null || value === undefined) {
        return []
      } else {

        if (this.return) {
          if(Array.isArray(value) && this.multiple) {
            var _value = [];
            for (var i = 0; i < value.length; i++) {
              _value.push(this.options.find((option) => String(option[this.return]) === String(value[i])));
            }
            value = _value;
          }
          else {
            value = this.options.find((option) => String(option[this.return]) === String(value)) || '';
          }
        }

        return this.multiple
          ? deepClone(value)
          : deepClone([value])
      }
    },
    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select (option, key) {
      /* istanbul ignore else */
      if (this.blockKeys.indexOf(key) !== -1 || this.disabled || option.$isLabel) return
      /* istanbul ignore else */
      if (this.max && this.multiple && this.internalValue.length === this.max) return
      if (option.isTag) {
        this.$emit('tag', option.label, this.id)
        this.search = ''
        if (this.closeOnSelect && !this.multiple) this.deactivate()
      } else {
        const isSelected = this.isSelected(option)
        if (isSelected) {
          if (key !== 'Tab') this.removeElement(option)
          return
        } else if (this.multiple) {
          this.internalValue.push(option)
        } else {
          this.internalValue = [option]
        }
        this.$emit('select', deepClone(option), this.id)

        let value = this.getValue()
        if(this.return) {
          value = this.multiple ? _(value).map(this.return).value() : value[this.return]
        }

        this.$emit('input', value, this.id)

        if (this.clearOnSelect) this.search = ''
      }

      if (this.closeOnSelect) this.deactivate()
    },

    removeElement (option, shouldClose = true) {

      if (this.disabled) return

      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate()
        return
      }

      const index = typeof option === 'object'
        ? this.valueKeys.indexOf(option[this.trackBy])
        : this.valueKeys.indexOf(option)

      this.internalValue.splice(index, 1)

      let value = this.getValue()
      if(this.return) {
        value = this.multiple ? _(value).map(this.return).value() : value[this.return]
      }

      this.$emit('input', value, this.id)
      this.$emit('remove', deepClone(option), this.id)

      if (this.closeOnSelect && shouldClose) this.deactivate()

      /*
      if (this.disabled) return

      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate()
        return
      }

      const index = typeof option === 'object'
        ? this.valueKeys.indexOf(option[this.trackBy])
        : this.valueKeys.indexOf(option)

      this.internalValue.splice(index, 1)
      this.$emit('input', this.getValue(), this.id)
      this.$emit('remove', deepClone(option), this.id)

      if (this.closeOnSelect && shouldClose) this.deactivate()
      */
    }
  }
}
export const mapObjects = {
  subscriptionToSearchFilters(Subscription){
    return {
      rentalObjectTypes : Subscription.SearchTerms.rentalObjectTypes,
      Neighbourhoods : Subscription.SearchTerms.administrativeUnitTownDistricts,
      MaxRent : Subscription.SearchTerms.maxRent,
      MinRooms : Subscription.SearchTerms.minRooms,
      MaxRooms : Subscription.SearchTerms.maxRooms,
      MinArea : Subscription.SearchTerms.minArea,
    };
  },

  searchFiltersToSearchTerms(searchFilters){
    return {
      rentalObjectTypes : searchFilters.rentalObjectTypes,
      administrativeUnitTownDistricts : searchFilters.Neighbourhoods,
      maxRent : searchFilters.MaxRent,
      minRooms : searchFilters.MinRooms,
      maxRooms : searchFilters.MaxRooms,
      minArea : searchFilters.MinArea
    };
  },
   mapToRentalObject(obj){
      return {
        Id : obj.id,
        Type: obj.ObjectType, //Lägenhet, parkering eller förråd
        neighbourhood : obj.area, //Område
        ObjectType : obj.RentalObjectTypeCaption, //Objekttyp text "Studentlägenhet"
        ObjectTypeCode : obj.ObjectTypeCode, //Objektstypkod "LGH20"
        RentalObjectType : obj.ObjectTypeCaption, //Bostadstyp text "1 rum och kök"
        rentalObjectTypeName: obj.RentalObjectTypeCaption, //Bostadstypskod
        address : obj.Address1, //Adress
        monthRent: obj.MonthRent, //Hyra
        quantityBRA : obj.QuantityBRA, //Storlek
        ImportantDate : obj.PublishedFrom,
        lastReply : obj.LastReply,
        vacantFrom : obj.VacantFrom,
        RoomCount : obj.RoomCount,
        images: obj.ImageUrlList,
        ResponseCodeCaption : obj.ResponseCodeCaption
      };
    }
 }
